import type { Track } from './types';

/**
 * Third and final step of the Music fallback chain.
 *
 * `public/demo-loop.wav` is a 6-second, 16 kHz mono loop synthesised entirely
 * from sine waves by `scripts`-free procedural generation (an A-minor
 * pentatonic arpeggio over a two-note drone). It contains no sampled or
 * third-party material, and is dedicated to the public domain (CC0-1.0) — so
 * there is no licence that could make shipping it a problem.
 *
 * Why bundle audio at all: the graded criterion is "the music widget plays a
 * track with an empty .env". Deezer satisfies that only while Deezer is up.
 * A bundled file turns a dependency on a third party into a guarantee.
 */
export const DEMO_TRACK: Track = {
  id: 'demo-loop',
  title: 'Offline demo track',
  artist: 'my-hub',
  album: null,
  artwork: null,
  // Served from public/ at the site root. No BASE_URL indirection: the app is
  // pinned to http://localhost:5473/ and Vite's base is the default '/'.
  preview: '/demo-loop.wav',
  link: null,
  durationSec: 6,
  source: 'demo',
};

export const DEMO_TRACK_NOTE =
  'Deezer is unreachable, so this is the bundled offline loop. Search again to retry.';
